<template>
    <div>
<!--        <el-select v-model="state" size="mini" @change="chooseStatus" style="margin-right: 9px;width:110px; ">-->
<!--            <el-option v-for="item in stateList" :key="item.key" :label="item.label" :value="item.key"></el-option>-->
<!--        </el-select>-->
        <el-table border ref="sgtable1" size="mini" :data="tableData" :height="tableHeight"
                  :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
            <!--            <el-table-column  align="center"   type="selection" width="50px" ></el-table-column>-->
            <el-table-column type="index" :label="$t('personInformation_serial_no')" width="50"></el-table-column>
            <el-table-column  prop="i_isuse"  width="100" show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_enabled_status')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.i_isuse" v-if="canEdit" :disabled="!canEdit" @input="changeFun(scope.row)">
                        <el-radio  :label="1">{{$t('personInformation_yes')}}</el-radio>
                        <el-radio  :label="-1">{{$t('personInformation_no')}}</el-radio>
                    </el-radio-group>
                    <div class="mrA" v-else>{{scope.row.i_isuse==-1?$t('personInformation_no'):$t('personInformation_yes')}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_username" :label="$t('personInformation_name')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_rytype"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_category')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_rytype" size="mini" @change="rytypeChange(scope.row,scope.$index)" filterable :remote="true"
                               :remote-method="typesearch" style="width:100%; "v-if="canEdit&&scope.row.i_state==1">
                        <el-option v-for="item in i_rytypeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_rytype}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_dept"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_department')}}</span>
                </template>
                <template slot-scope="scope">
                  <el-popover v-if="canEdit" placement="bottom-end" width="300" trigger="click" class="maxHeigth" style="max-height: 400px;overflow-y: auto;">
                    <el-tree ref="tree" :data="bmList" lazy :load="loadNode" :props="defaultProps"
                     node-key="i_id" @node-click="handleNodeClick(scope.row,$event)"accordion :highlight-current='true'></el-tree>
                    <div slot="reference" class="tree-select-trigger">
                                        <span  v-if="scope.row.vc_dept">{{scope.row.vc_dept}}</span>
                                        <span style="color: #409EFF" v-else>{{$t('personInformation_please_select_department')}}</span>

<!--                      {{ scope.row.vc_dept||'请选择部门'}}-->
                    </div>
                     </el-popover>
                     <div class="mrA" v-else>{{scope.row.vc_dept}}</div>
                </template>
<!--                <template slot-scope="scope">-->
<!--                    <el-cascader size="mini" v-model="scope.row.bmvalue" :show-all-levels="false" :options="bmList" :props="bmprops" @change="bmChange(scope.row,scope.$index)"style="width:100%; "v-if="canEdit"></el-cascader>-->
<!--                    <div class="mrA" v-else>{{scope.row.vc_dept}}</div>-->
<!--                </template>-->
            </el-table-column>
            <el-table-column  prop="i_gsid"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_company')}}</span>
                </template>
                <template slot-scope="scope">
                    <div class="mrA">{{scope.row.vc_gsname}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_station"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_position')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_station" size="mini" @change="stationChange(scope.row,scope.$index)" filterable :remote="true"
                               :remote-method="stationsearch" style="width:100%; "v-if="canEdit">
                        <el-option v-for="item in i_stationList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_station}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_zwid"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_job_rank')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_zwid" size="mini" @change="zwChange(scope.row,scope.$index)" filterable :remote="true"
                               :remote-method="zwsearch" style="width:100%; "v-if="canEdit">
                        <el-option v-for="item in i_zwList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_zw}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_state" width="100" show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('personInformation_concurrent')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-checkbox :disabled="!canEdit" v-model="scope.row.i_state" @input="changeFun(scope.row,'JG')" size="mini" :true-label="2" :false-label="1"></el-checkbox>
<!--                    <div class="mrA" v-else>{{scope.row.i_state}}</div>-->
                </template>
            </el-table-column>
            <el-table-column  prop="i_state" width="100" :label="$t('personInformation_remark')"  show-overflow-tooltip>

                <template slot-scope="scope">
                    <el-input v-if="canEdit" v-model="scope.row.vc_note" size="mini" @input="noteChange" :placeholder="$t('personInformation_please_input')"></el-input>
                    <div class="mrA" v-else>{{scope.row.vc_note}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="dt_createtime" :label="$t('personInformation_registration_time')" show-overflow-tooltip></el-table-column>
            <el-table-column :label="$t('personInformation_operation')" width="40" align="center">
                <template slot="header" slot-scope="scope" v-if="canEdit">
                    <el-button  icon="el-icon-plus"  @click="addRow"   size="mini" v-if="canEdit" type="text" ></el-button>
                    <!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                </template>
                <template slot-scope="scope">
                    <el-button  icon="el-icon-minus" type="text"  v-if="canEdit&&scope.row.i_id==0" @click="deleteRow(scope.row,scope.$index)"  size="mini"></el-button>
                    <!--                    <el-button  type="text"  @click="addSg(scope.row,scope.$index)"  size="mini" >编辑</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <div  class="center">
            <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
            <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "TransferHistory",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            const self=this;
            return {
                bmprops:{
                    lazy: true,
                    children: 'children',
                    label: 'label',
                    leaf: 'isLeaf',
                    value:'i_id',
                    lazyLoad (node, resolve) {
                        self.loadNode(node, resolve)
                    }
                },
                tableHeight: 0,
                baseerp: '',
               tableData:[],
                i_rytypeList:[],
                i_stationList:[],
                i_zwList:[],
                bmList:[],
                canEdit:false,
                disabled:false,
                type_search:'',
                station_search:'',
                zw_search:'',
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            this.getUserDeptRelations()
            // console.log(this.data,'this.data')
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            noteChange(){
                row.change='change'
            },
            changeFun(row,type){
                row.change='change'
                if(type){row.i_isuse=1}
            },
            chooseStatus(){
                this.currentPage=1
                this.getUserDeptRelations()
            },
            addRow(row,index){
                this.tableData.unshift({
                    i_id:0,
                    vc_username:this.data.val.vc_username,
                    i_userid:this.data.val.i_userid,
                    i_isuse:1,
                    i_state:2,
                    i_dept:'',
                    i_station:'',
                    i_zwid:'',
                    i_rytype:null,

                    vc_lruname:'',
                    dt_createtime:'',
                })
            },
            deleteRow(row,index){
                this.tableData.splice(index,1);
                // if(row.id!=0)this.formData.delgoods.push(row.id);
                // this.getSum(row,index)
            },
            save(){
                let tableData=this.tableData.filter(b=>b.change=='change'),
                    hasstate=this.tableData.filter(b=>b.i_state==1&&(b.i_isuse==1||b.i_isuse==0)),
                    cantsave=false;
                if(tableData.length==0){
                    this.$message.warning(this.$t('personInformation_no_changes'));
                    return
                }
                if(hasstate.length==0){
                    this.$message.warning(this.$t('personInformation_no_direct_position'));
                    return
                }
                if(hasstate.length>1){
                    this.$message.warning(this.$t('personInformation_only_one_direct_position_allowed'));
                    return
                }
                if(hasstate.length==1&&hasstate[0].i_isuse==-1){
                    this.$message.warning(this.$t('personInformation_direct_position_disabled'));
                    return
                }
                this.addUserDeptRelation(tableData)
            },
            editForm(){
                this.canEdit=true;
                this.getUserHeadShip('','hr_headship');
                this.getUserHeadShip('','hr_station');
                this.getUserTypeList();
            },
            cancel(){
                this.$emit('close')
            },
            rytypeChange(row,index){
                // for(let i=0;i<this.tableData.length;i++){
                //     this.tableData[i].vc_rytype=this.i_rytypeList.find(i=>row.i_rytype==i.i_id).vc_name
                //     this.tableData[i].change='change'
                // }
                this.tableData.map(t=>{
                    t.vc_rytype=this.i_rytypeList.find(i=>row.i_rytype==i.i_id).vc_name
                    t.change='change'
                    t.i_rytype=row.i_rytype
                })
                // this.tableData[index].vc_rytype=this.i_rytypeList.find(i=>row.i_rytype==i.i_id).vc_name
                // row.change='change'
            },
            typesearch(val){
                this.type_search=val;
                this.getUserTypeList();
            },
            async getUserTypeList(){
                let param={
                    vc_search:this.type_search,
                };
                let res=await API.getUserTypeList(param);
                if ( res.code == 1 ){
                    this.i_rytypeList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            stationChange(row,index){
                this.tableData[index].vc_station=this.i_stationList.find(i=>row.i_station==i.i_id).vc_name
                row.change='change'
            },
            stationsearch(val){
                this.station_search=val;
                this.getUserHeadShip(this.station_search,'hr_station');
            },
            zwChange(row,index){
                row.change='change'
                this.tableData[index].vc_zw=this.i_zwList.find(i=>row.i_zwid==i.i_id).vc_name
            },
            zwsearch(val){
                this.zw_search=val;
                this.getUserHeadShip(this.zw_search,'hr_headship');
            },
            async getUserHeadShip(search,type){
                let param={
                    vc_search:search,
                    vc_type:type,
                };
                let res=await API.getUserHeadShip(param);
                if ( res.code == 1 ){
                    if(type=='hr_station'){
                        this.i_stationList=res.data;
                    }else{
                        this.i_zwList=res.data;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //列表
            async getUserDeptRelations(){
                let param={
                    i_userid:this.data.val.i_userid,
                };
                let res=await API.getUserDeptRelations(param);
                if ( res.code == 1 ){
                    res.data.relations.map(item=>{item.oldGsid=item.i_gsid;item.i_isuse=1})
                    this.tableData=res.data.relations;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //新增
            async addUserDeptRelation(tableData){

                let param={
                    relationList:tableData,
                };
                let res=await API.addUserDeptRelation(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.getUserDeptRelations()
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            handleNodeClick(row, node){
                //console.log(row,node,'treeData')
                if(!node.hasSubDept){
                    //console.log('this.tableData',this.tableData)
                    let data = this.tableData.filter(item=>item.i_id != row.i_id)
                    let same = data.some(item=>item.i_dept==node.i_id)
                    if(same){
                        this.$message.error(this.$t('personInformation_duplicate_department_not_allowed'))
                        return
                    }
                    this.$set(row, 'i_dept', node.i_id)
                    this.$set(row, 'vc_dept',  node.vc_name)
                    this.$set(row, 'i_gsid',  node.i_gsid)
                    this.$set(row, 'vc_gsname',  node.vc_gsname)
                    this.$set(row, 'departmentPopoverVisible', false)
                    row.change='change'
                }
            },
            bmChange(val,index){},
            loadNode(node, resolve) {
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0,i_pid:0,label:this.$t('personInformation_all'),vc_name:this.$t('personInformation_all'),children:[],isLeaf:false};
                    _this.getDeptTree(val,resolve);

                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getDeptTree(node.data,resolve);
                }
            },
            async getDeptTree({value=0,type='depart'},resolve){
                let param = {
                    i_pid:value,
                    i_isuse:1,
                    isiysuser:1,
                };
                let res = await API.getDeptTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= !one.hasSubDept;
                            hash.i_level= one.i_level;
                            hash.label= one.vc_name;
                            hash.value= one.i_id;
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    .red-star{
        color: red;
    }
    .el-radio{
        margin-right: 5px !important;
    }
    .el-input,.el-select,.el-radio-group{
        width: auto !important;
        margin-left: -10px;
    }
    .el-tree{
        max-height: 400px;
        overflow-y: auto;
    }
    /deep/{
        .el-tree{
            max-height: 400px;
            overflow-y: auto;
        }
    }

</style>